import { useEntity, EntityActions, TabNav, DownloadButton, ActionDropdown, useDownloadHandler } from 'components';
import { InvoiceSource, PaymentStateBadge, useNavLinks } from 'modules/invoicing/common';
import permissions from 'modules/invoicing/income/permissions';
import { bookingActions } from 'modules/invoicing/income';
import { Button, Stack } from '@ff-it/ui';
import { ReactElement } from 'react';
import { Income } from 'modules/invoicing/income/types';
import { InvoiceStateTag } from 'modules/invoicing/common/InvoiceStateTag';

export function Nav(): ReactElement {
  const { item } = useEntity<Income>();
  const nav = useNavLinks(item, permissions);
  const {
    id,
    state,
    payer,
    number,
    sums: { paym_state },
    token,
  } = item;

  const onAcceptanceClick = useDownloadHandler({ url: `invoicing/income/${id}/acceptance.docx` });
  const onPeppolClick = useDownloadHandler({ url: `invoicing/income/${id}/peppol.xml` });
  return (
    <div className="container-fluid header header--income">
      <div className="d-flex flex-row align-items-center my-2">
        <h2 className="mt-0">
          <InvoiceSource {...item} className="mr-1" />
          <strong>{payer.title}</strong>
          <small className="text-muted ml-2">
            #{number} <PaymentStateBadge state={paym_state} />
          </small>
        </h2>
        <InvoiceStateTag state={state} size="sm" className="ml-2" />
        {state !== 'CANCELED' && (
          <Stack direction="horizontal" ml="auto">
            <EntityActions actions={bookingActions} />
            {state === 'DRAFT' ? (
              <Button variant="secondary" className="ml-1" size="sm" asChild icon="file-pdf">
                <a href={`/api/v1/i/${token}/`} target="_blank">
                  Invoice
                </a>
              </Button>
            ) : (
              <DownloadButton url={`invoicing/income/${id}.pdf`} variant="secondary" icon="file-pdf" size="sm">
                Invoice
              </DownloadButton>
            )}
            <ActionDropdown
              variant="secondary"
              size="sm"
              icon="ellipsis-vertical"
              actions={[
                {
                  action: 'acceptance',
                  button: {
                    icon: 'file-signature',
                    children: 'Acceptance certificate',
                    onClick: onAcceptanceClick,
                  },
                },
                {
                  action: 'peppol',
                  button: {
                    icon: 'file-xml',
                    children: 'Peppol BIS3 XML',
                    onClick: onPeppolClick,
                  },
                },
              ]}
            />
          </Stack>
        )}
      </div>
      <TabNav nav={nav} />
    </div>
  );
}
